export default __webpack_public_path__ + "static/media/warning.a6bdbe85.svg";